import CombineCard from './CombineCard';

export default CombineCard;
